import { Store } from '@ping/utils';

interface IMainSidebarStore {
  /** `true` while a main sidebar is mounted, so the header only offers the drawer where navigation exists. */
  isAvailable: boolean;
  isDrawerOpen: boolean;
}

// --------------------------------------------------------------------------------
// MAIN SIDEBAR STORE
// --------------------------------------------------------------------------------
export const useMainSidebarStore = new Store<IMainSidebarStore>({ isAvailable: false, isDrawerOpen: false })
  .withDevTools()
  .build();

// --------------------------------------------------------------------------------
// MAIN SIDEBAR SELECTORS
// --------------------------------------------------------------------------------
export const isMainSidebarAvailableSelector = (state: IMainSidebarStore) => state.isAvailable;
export const isMainSidebarDrawerOpenSelector = (state: IMainSidebarStore) => state.isDrawerOpen;

// --------------------------------------------------------------------------------
// MAIN SIDEBAR API
// --------------------------------------------------------------------------------
export const mainSidebarStore = {
  /** Leaving the sidebar behind must never leave its drawer open over another page. */
  setAvailable: (isAvailable: boolean) =>
    useMainSidebarStore.setState(state => ({ isAvailable, isDrawerOpen: isAvailable && state.isDrawerOpen })),
  setDrawerOpen: (isDrawerOpen: boolean) => useMainSidebarStore.setState({ isDrawerOpen }),
  openDrawer: () => useMainSidebarStore.setState({ isDrawerOpen: true }),
  closeDrawer: () => useMainSidebarStore.setState({ isDrawerOpen: false }),
};
